var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/Page.ts
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import { MongoEntity } from "@adornis/baseql/entities/mongoEntity.js";
import { registerMutation, registerSubscription } from "@adornis/baseql/metadata/register.js";
import { getCollectionHandle, getRawCollection } from "@adornis/baseql/server/collections.js";
import { validate } from "@adornis/validation/decorators.js";
import { nonOptional } from "@adornis/validation/functions/nonOptional.js";
import { map } from "rxjs";
import { Base } from "./Base.js";
var PageMetaData = class extends AdornisEntity {
};
PageMetaData._class = "PageMetaData";
__decorateClass([
  Field((type) => String)
], PageMetaData.prototype, "backgroundColor", 2);
__decorateClass([
  Field((type) => String)
], PageMetaData.prototype, "color", 2);
PageMetaData = __decorateClass([
  Entity()
], PageMetaData);
var Page = class extends MongoEntity {
  static async beforeCreate(entity) {
    await super.beforeCreate(entity);
    if (!entity.path)
      entity.path = await this._generateUniqueSlugFromName(entity.name);
    await this.checkUniquePath(entity);
  }
  static async beforeUpdate(oldEntity, entity) {
    await super.beforeUpdate(oldEntity, entity);
    if (entity.has("path") && oldEntity.path !== entity.path)
      await this.checkUniquePath(entity);
  }
  static async checkUniquePath(entity) {
    if (!entity.path)
      throw new Error("Jede Seite braucht einen eindeutigen Pfad \xFCber den sie erreichbar ist");
    const existingPaths = await (await getRawCollection(this._collectionName)).countDocuments({ path: this.generatePathFindRegex(entity.path) });
    if (existingPaths)
      throw new Error("Neue Seite konnte nicht erstellt werden, da eine Seite mit dem selben Pfad bereits existiert");
  }
  static async _generateUniqueSlugFromName(name) {
    if (!name)
      return "";
    const sluggedName = name.toLowerCase().replace(/\s/gi, "-").replaceAll(/ä/gi, "ae").replaceAll(/ö/gi, "oe").replaceAll(/ü/gi, "ue").replace(/[^\w-]/gi, "");
    const numExistingPaths = await (await getRawCollection(this._collectionName)).countDocuments({ path: { $regex: sluggedName, $options: "i" } });
    if (numExistingPaths)
      return `${sluggedName}-${numExistingPaths + 1}`;
    return sluggedName;
  }
  static async createPath(name, parent) {
    return `${parent ?? ""}${parent?.endsWith("/") ? "" : "/"}${await this._generateUniqueSlugFromName(name)}`;
  }
  static generatePathFindRegex(path, matchSubPathsOnly = false) {
    return { $regex: `^${path.replace(/(\W)/, "\\$1")}${matchSubPathsOnly ? "\\/" : "$"}`, $options: "i" };
  }
};
Page._class = "Page";
Page._collectionName = "pages";
__decorateClass([
  validate(nonOptional()),
  Field((type) => String)
], Page.prototype, "name", 2);
__decorateClass([
  Field((type) => String)
], Page.prototype, "path", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => [Base], { default: (v) => v ?? [] })
], Page.prototype, "content", 2);
__decorateClass([
  Field((type) => PageMetaData, { default: (v) => v ?? new PageMetaData({}) })
], Page.prototype, "metaData", 2);
Page = __decorateClass([
  Entity()
], Page);
var subscribePageByPath = registerSubscription({
  operationName: "subscribePageByPath",
  resolve: (path) => (gqlFields) => getCollectionHandle(Page._collectionName).watchQuery({ path }).pipe(map((pages) => pages[0])),
  type: () => Page,
  params: [{ name: "path", type: () => String }]
});
var createPage = registerMutation({
  operationName: "createBuildifyPage",
  resolve: (page, parentPath) => async (gqlFields) => {
    page.path ||= await Page.createPath(page.name ?? "Neue Seite", parentPath);
    await page.create();
    return page;
  },
  type: () => Page,
  params: [
    { name: "page", type: () => Page },
    { name: "parentPath", type: () => String }
  ]
});
var subscribeSubPagesOfPath = registerSubscription({
  operationName: "subscribeSubPagesOfPath",
  resolve: (path) => (gqlFields) => getCollectionHandle(Page._collectionName).watchQuery({ path: Page.generatePathFindRegex(path, true) }),
  type: () => [Page],
  params: [{ name: "path", type: () => String }]
});
export {
  Page,
  PageMetaData,
  createPage,
  subscribePageByPath,
  subscribeSubPagesOfPath
};
